export default function compact<T>(value?: T | undefined | null | false): value is T {
  return !!value;
}
